export enum CalendarViewType {
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  list = 'list'
}
